import { useExonnHubCatalogParams } from "src/admin/modules/b2b-gate-order/components/ExonnHub/hooks/useExonnHubCatalogParams.ts";
import { useExonnHubCatalog } from "src/admin/modules/b2b-gate-order/components/ExonnHub/hooks/useExonnHubCatalog.tsx";
import { keepPreviousData } from "@tanstack/react-query";
import { observer } from "mobx-react-lite";
import { Flex } from "src/components/Flex.tsx";
import { useExonnHubStore } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubStore.ts";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import * as styles from "./Breadcrumbs.style.ts";

type Breadcrumb = {
  id: string | undefined;
  title: string;
  path: string[];
};

export const Breadcrumbs = observer(() => {
  const listParams = useExonnHubCatalogParams();
  const { t } = useTranslation(TranslationNamespaceEnum.ExonnHubComponent);

  const { data: catalogData } = useExonnHubCatalog(listParams, {
    placeholderData: keepPreviousData,
  });

  const category_path = catalogData?.category_path || [];

  if (category_path.length === 0) {
    return null;
  }

  const breadcrumbs: Breadcrumb[] = [
    {
      id: undefined,
      title: t("rootCategory"),
      path: [],
    },
    ...category_path.map((item, index) => ({
      ...item,
      path: [...category_path.slice(0, index + 1).map((item) => item.id)],
    })),
  ];

  return (
    <div css={styles.root}>
      {breadcrumbs.map((item, index) => {
        const isLast = breadcrumbs.length === index + 1;
        return <Breadcrumb isLast={isLast} item={item} />;
      })}
    </div>
  );
});

const Breadcrumb = observer(
  ({ isLast, item }: { isLast: boolean; item: Breadcrumb }) => {
    const store = useExonnHubStore();
    const handleSelect = () => {
      store.setActiveCategory(item.id);
      store.setCategoryPath(item.path);
    };
    return (
      <Flex
        alignItems={"center"}
        justifyContent={"center"}
        flexDirection="row"
        gap={"5px"}
        flexShrink={0}
      >
        <div
          css={styles.item({
            isActive: isLast,
          })}
          onClick={handleSelect}
        >
          {item.title}
        </div>
        {!isLast && <div css={styles.separator}>/</div>}
      </Flex>
    );
  },
);
